import { gql } from '@apollo/client';
import {
    CYCLE_COUNT_FIELDS,
    CYCLE_COUNT_LOCATION_FIELDS,
    CYCLE_COUNT_SHIPPER_FIELDS,
    CYCLE_COUNT_TEMPLATE_FIELDS,
} from './fragments';

export const CYCLE_COUNTS_LIST = gql`
    ${CYCLE_COUNT_FIELDS}
    ${CYCLE_COUNT_LOCATION_FIELDS}
    ${CYCLE_COUNT_SHIPPER_FIELDS}
    query CycleCountsList($where: cycle_counts_bool_exp!) {
        cycle_counts(where: $where, order_by: [{ date: desc_nulls_last }, { created_at: desc }]) {
            ...CycleCountFields
            warehouse {
                location_id
                location_name
            }
            assigned_teammate {
                teammate_id
                username
            }
            count_locations {
                ...CycleCountLocationFields
            }
            shippers {
                ...CycleCountShipperFields
                shipper {
                    client_id
                    business_name
                }
            }
        }
    }
`;

export const CYCLE_COUNT_LIST_INVENTORY = gql`
    query CycleCountListInventory($warehouse_ids: [uuid!]!) {
        items(
            where: {
                pallet: {
                    warehouse_id: { _in: $warehouse_ids }
                    warehouse_location: { _is_null: false }
                }
            }
        ) {
            item_id
            sku
            pallet {
                pallet_id
                warehouse_id
                warehouse_location
            }
            order {
                order_id
                order_number
                dropoff_name
                order_shipper {
                    client_id
                    business_name
                }
            }
        }
    }
`;

export const CYCLE_COUNT_WAREHOUSES = gql`
    query CycleCountWarehouses($client_id: uuid!) {
        locations(
            where: {
                client_id: { _eq: $client_id }
                warehouse_racks: { _is_null: false }
            }
            order_by: { location_name: asc }
        ) {
            location_id
            location_name
            warehouse_racks
        }
    }
`;

export const CYCLE_COUNT_TEMPLATES = gql`
    ${CYCLE_COUNT_TEMPLATE_FIELDS}
    query CycleCountTemplates($client_id: uuid!, $warehouse_id: uuid!) {
        cycle_count_templates(
            where: {
                client_id: { _eq: $client_id }
                warehouse_id: { _eq: $warehouse_id }
            }
            order_by: { name: asc }
        ) {
            ...CycleCountTemplateFields
        }
    }
`;

export const CYCLE_COUNT_SHIPPER_INVENTORY_OPTIONS = gql`
    query CycleCountShipperInventoryOptions($warehouse_id: uuid!) {
        items(
            where: {
                pallet: {
                    warehouse_id: { _eq: $warehouse_id }
                    warehouse_location: { _is_null: false }
                }
                order: { shipper_id: { _is_null: false } }
            }
        ) {
            item_id
            pallet {
                pallet_id
                warehouse_location
            }
            order {
                order_id
                shipper_id
                order_shipper {
                    client_id
                    business_name
                }
            }
        }
    }
`;
